import * as React from 'react';
import { translate } from 'react-i18next';
import { InjectedFormProps, Field } from 'redux-form';
import * as c from 'models/constants';
import { IModalAction } from 'models/modal';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { IPoll } from 'models/polls/poll';
import { required } from 'helpers/validationattributes';
import { PortalPageSection } from 'components/PortalStructure';
import { WhiteButton } from 'components';
import { PortalInputField, PortalFieldLabel } from 'components/FormControls';

interface IProps extends InjectedFormProps {
	currentFormValues?: IPortalPageSection;
	section?: IPortalPageSection;
	index?: number;
	baseUrl?: string;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
	change?: (field: any, value: any) => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageSectionItemPoll extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.searchPoll = this.searchPoll.bind(this);
		this.selectPoll = this.selectPoll.bind(this);
	}

	public componentDidMount() {
		if (
			this.props.currentFormValues &&
			this.props.currentFormValues.items &&
			!this.props.currentFormValues.items[this.props.index]
		) {
			this.props.change('items[' + this.props.index + '].type', c.PORTAL_PAGE_SECTION_ITEM_POLL);
			this.props.change('items[' + this.props.index + '].elements', []);
			this.props.change('items[' + this.props.index + '].elements[0]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[1]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[2]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[3]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[4]', { text: null, redirectUrl: null });
		}
	}

	private searchPoll(e: any, func: (data: IPoll) => void) {
		e.preventDefault();
		this.props.showModal('SearchPolls', {
			selectPoll: func,
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
		});
	}

	private selectPoll(data: IPoll) {
		this.props.closeModal();
		this.props.change('items[' + this.props.index + '].elements[2].text', data.id);
		this.props.change('items[' + this.props.index + '].elements[3].text', data.questionText);
		this.props.change('items[' + this.props.index + '].elements[4].text', JSON.stringify(data.pollOptions));
	}

	public render() {
		const { t, currentFormValues, index } = this.props;

		let selectedQuestionTextElement = null;
		if (
			currentFormValues &&
			currentFormValues.items &&
			currentFormValues.items.length > 0 &&
			currentFormValues.items[index] &&
			currentFormValues.items[index].elements &&
			currentFormValues.items[index].elements.length > 0 &&
			currentFormValues.items[index].elements[3]
		) {
			selectedQuestionTextElement = (
				<div className="row">
					<div className="col-md-12">{(currentFormValues.items[index].elements[3] as ISectionTextElement).text}</div>
				</div>
			);
		}

		return (
			<PortalPageSection usage="admin">
				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + index + '].elements[1].text'}
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('PortalPage_SectionItems_SectionItemPoll_Label_Title')}
							showLabel={true}
							validate={[required]}
						/>
						<Field
							name={'items[' + index + '].elements[0].text'}
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('PortalPage_SectionItems_SectionItemPoll_Placeholder_TitlePart2')}
							showLabel={true}
							validate={[required]}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<PortalFieldLabel name="search" text={t('PortalPage_SectionItems_SectionItemPoll_Label_SearchForPoll')} />
						<WhiteButton type="submit" usage="admin" onClick={(event: any) => this.searchPoll(event, this.selectPoll)}>
							{t('PortalPage_SectionItems_SectionItemPoll_Label_SelectPoll')}
						</WhiteButton>
					</div>
				</div>

				{selectedQuestionTextElement}
			</PortalPageSection>
		);
	}
}

export { ManageSectionItemPoll };
